import React from 'react'
import PropTypes from 'prop-types'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import { withHandlers, setPropTypes, compose } from 'recompose'
import withGoogleAPI from '../../services/maps/withGoogleAPI'

export const withMarkerHandlers = withHandlers(() => {
  const refs = {
    map: null,
    marker: null
  }
  return {
    onMapMounted: () => node => {
      refs.map = node
    },
    onMarkerMounted: () => node => {
      refs.marker = node
    },
    handleMarkerDragEnd: props => () => {
      const { onPositionChanged } = props
      if (!refs.marker) return
      const position = refs.marker.getPosition()
      const newPos = {
        lat: position.lat(),
        lng: position.lng()
      }
      if (typeof onPositionChanged === 'function') {
        onPositionChanged(newPos)
      }
    }
  }
})

const MapBox = ({
  lat,
  lng,
  mapOptions,
  isMarkerDraggable,
  onMapMounted,
  onMarkerMounted,
  handleMarkerDragEnd
}) => (
  <GoogleMap
    ref={onMapMounted}
    defaultZoom={18}
    options={mapOptions}
    center={{ lat: Number(lat), lng: Number(lng) }}
  >
    {lat &&
      lng && (
        <Marker
          ref={onMarkerMounted}
          position={{ lat: Number(lat), lng: Number(lng) }}
          draggable={Boolean(isMarkerDraggable)}
          onDragEnd={handleMarkerDragEnd}
        />
      )}
  </GoogleMap>
)

MapBox.defaultProps = {
  mapOptions: {
    disableDefaultUI: false,
    clickableIcons: true,
    scrollwheel: false,
    draggable: true,
    disableDoubleClickZoom: false,
    streetViewControl: false
  }
}

MapBox.propTypes = {
  lat: PropTypes.string.isRequired,
  lng: PropTypes.string.isRequired,
  isMarkerDraggable: PropTypes.bool,
  //https://developers.google.com/maps/documentation/javascript/reference?hl=es#MapOptions
  mapOptions: PropTypes.object,
  onMapMounted: PropTypes.func,
  onMarkerMounted: PropTypes.func
}

const decorator = compose(
  setPropTypes({
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isMarkerDraggable: PropTypes.bool,
    onPositionChanged: PropTypes.func,
    mapOptions: PropTypes.object
  }),
  withGoogleAPI,
  withMarkerHandlers,
  withGoogleMap
)

export default decorator(MapBox)



// WEBPACK FOOTER //
// ./src/ui/maps/map-box.js